module.exports = ".filter-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n}\r\n\r\n.filter-container div {\r\n    padding: 0 0.8rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/salaries/payroll-list/payroll-list.component.css
// module id = ./src/app/components/salaries/payroll-list/payroll-list.component.css
// module chunks = main